export const WEB = 'web'
export const PHONE = 'phone'
